exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app-description__p+.app-description__p{margin-top:.5rem}.app-description__link{color:#186faf}.app-description__link:hover{text-decoration:underline}", ""]);

